import React, { useState } from "react";
import "./ForgotPassword.css";
import Qcr from "../../images/qcr.png";
import Container from "react-bootstrap/Container";
import { Row, Col, Button, Form, Toast } from "react-bootstrap";
import { ForgotPasswordAPI } from "../../apis/LoginAPI";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [showWrongUser, setWrongUser] = useState(false); //
  const [showUserSuccess, setUserSuccess] = useState(false); //
  const [isDisabled, setIsDisabled] = useState(false);
  const [validated, setValidated] = useState(false);

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
    }
    setValidated(true);
    //console.log({ email });
    var result = await ForgotPasswordAPI({
      useremail: email,
    });
    //console.log(result);
    if (result.status === 200) {
      setUserSuccess(true);
      setIsDisabled((current) => !current);
    } else if (result.status === 201) setWrongUser(true);
  };
  //

  return (
    <>
      <Container fluid>
        <Row>
          <Col className="p-0">
            <div className="login-wrapper">
              <Container fluid>
                <div className="login-wrapper-inner">
                  <div className="login-form">
                    <div className="qcryearslogo">
                      <img src={Qcr} alt="QCR" width={149} />
                    </div>
                    <h1>Reset Password</h1>
                    <Form
                      className="login-box"
                      noValidate
                      validated={validated}
                      onSubmit={handleForgotPassword}
                    >
                      <div class="mb-3 me-3">
                        Enter the email address associated with your account,
                        and we'll email you a link to reset your password.
                      </div>
                      <Form.Group
                        className="mb-3"
                        controlId="validationCustom01"
                      >
                        <Form.Control
                          required
                          type="email"
                          placeholder="Enter Email"
                          onChange={handleEmail}
                        />
                      </Form.Group>
                      <Button
                        className={
                          isDisabled ? "login-button disabled" : "login-button"
                        }
                        variant="primary"
                        type="submit"
                        onClick={handleForgotPassword}
                      >
                        Send Reset Link
                      </Button>
                    </Form>
                  </div>
                </div>
              </Container>
            </div>
          </Col>
        </Row>
      </Container>
      {/* OTP did not match */}
      <Toast
        className="wrong-otp-toast"
        position="top-end"
        show={showWrongUser}
        onClose={() => setWrongUser(false)}
        delay={3000}
        autohide
      >
        <Toast.Body>
          <h3>Error</h3>
          <p>
            User does not exist. <br />
            Please try again with correct user
          </p>
        </Toast.Body>
      </Toast>
      {/* Successfully Loged in */}
      <Toast
        className="wrong-otp-toast"
        position="top-end"
        show={showUserSuccess}
        onClose={() => setUserSuccess(false)}
        delay={3000}
        autohide
      >
        <Toast.Body>
          <h3>Success</h3>
          <p>Reset Password link sent to {email} email</p>
        </Toast.Body>
      </Toast>
    </>
  );
}
